
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function createTableContainerClass(isMobile: boolean, minWidth: string = "320px") {
  return isMobile ? `overflow-x-auto min-w-[${minWidth}]` : "w-full";
}
